(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-simple"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-style1"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
        }
    }
    customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
        constructor() {
            super();
            
            this.productId = this.dataset.productId;
            console.log('ProductRecommendations initialized for product:', this.productId);
            console.log('Data URL:', this.dataset.url);
            
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);
                
                console.log('Fetching recommendations from:', this.dataset.url);
                
                fetch(this.dataset.url)
                .then(response => {
                    console.log('Response status:', response.status);
                    return response.text();
                })
                .then(text => {
                    console.log('Response received, length:', text.length);
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
                    
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        const hasProducts = recommendations.querySelector('.product-recommendations__inner');
                        
                        if (hasProducts) {
                            console.log('Recommendations found, updating innerHTML');
                            this.innerHTML = recommendations.innerHTML;
                            this.initializeAfterLoad();
                        } else {
                            console.log('No products in recommendations, keeping fallback collection products');
                            // El contenido del servidor ya tiene los productos de la colección
                            this.initializeAfterLoad();
                        }
                    } else {
                        console.log('No recommendations found, keeping fallback collection products');
                        // El contenido del servidor ya tiene los productos de la colección
                        this.initializeAfterLoad();
                    }
                })
                .catch(e => {
                    console.error('Error fetching recommendations:', e);
                    console.log('Using fallback collection products');
                    // En caso de error, usar los productos de la colección que ya están cargados
                    this.initializeAfterLoad();
                });
            }
        
            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }

        initializeAfterLoad() {
            if (typeof vela !== 'undefined' && typeof vela.swatchProduct === 'function') {
                vela.swatchProduct();
            }

            // Update wishlist button status
            if (typeof vela !== 'undefined' && vela.wishlist && typeof vela.wishlist.updateWishlist === 'function') {
                vela.wishlist.updateWishlist();
            }

            if (typeof $ !== 'undefined') {
                setTimeout(() => {
                    $('body').trigger('carousel:init', '.js-recommendations');
                    $('body').trigger('vela:countdown', '[data-countdown]');
                }, 100);
            }
        }
    }
    
    if (!customElements.get('product-recommendations')) {
        customElements.define('product-recommendations', ProductRecommendations);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-viewed"] && !Shopify.designMode) return;
  try {
    
    var vela = window.vela || {};
    vela.recentlyViewed = {
        name: 'vela_recently_viewed',
        symbol: '|',
        maximumItems: 10,
        exists: 365,
        products: []
    };

    // Load product handle from cookie
    var cookieRecentlyViewed = vela.getCookie(vela.recentlyViewed.name);
    console.log('Cookie value:', cookieRecentlyViewed);
    
    if (cookieRecentlyViewed !== '') {
        var products = cookieRecentlyViewed.split(vela.recentlyViewed.symbol);
        products.forEach(function(item) {
            vela.recentlyViewed.products.push(item);
        });
    }
    
    console.log('Recently viewed products:', vela.recentlyViewed.products);

    // Add product handle to cookie.
    var pathname = window.location.pathname;
    if (vela && pathname.indexOf('/products/') !== -1) {
        var productHandle = pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        var currentIndex = vela.recentlyViewed.products.indexOf(productHandle);
        if (currentIndex === -1) {
            vela.recentlyViewed.products.unshift(productHandle);
            vela.recentlyViewed.products = vela.recentlyViewed.products.splice(0, vela.recentlyViewed.maximumItems);
        } else {
            vela.recentlyViewed.products.splice(currentIndex, 1);
            vela.recentlyViewed.products.unshift(productHandle);
        }

        if (vela.recentlyViewed.products.length > 0) {
            var productHandles = vela.recentlyViewed.products.join(vela.recentlyViewed.symbol);
            vela.setCookie(vela.recentlyViewed.name, productHandles, vela.recentlyViewed.exists);
        }
    }

    class ProductRecentlyViewed extends HTMLElement {
        constructor() {
            super();
            console.log('ProductRecentlyViewed constructor called');

            this.hiddenClass = 'd-none';
            this.container = this.querySelector('[data-products]');
            this.limit = parseInt(this.dataset.limit, 10);
            
            console.log('Container found:', !!this.container);
            console.log('Limit:', this.limit);

            if (this.container) {
                this.layout = this.container.dataset.products;
                console.log('Layout:', this.layout);

                if (document.readyState === 'loading') {
                    document.addEventListener("DOMContentLoaded", () => {
                        this.initPages();
                    });
                } else {
                    this.initPages();
                }
            }
        }

        initPages() {
            console.log('initPages called');
            console.log('vela object:', vela);
            console.log('recentlyViewed:', vela.recentlyViewed);
            console.log('products array:', vela.recentlyViewed.products);
            
            if (vela && vela.recentlyViewed && vela.recentlyViewed.products) {
                console.log('Products length:', vela.recentlyViewed.products.length);
                
                if (vela.recentlyViewed.products.length > 1) {
                    console.log('Rendering pages...');
                    this.renderPages();
                } else {
                    console.log('Not enough products, hiding section');
                    this.classList.add(this.hiddenClass);
                }
            } else {
                console.log('No recently viewed data, hiding section');
                this.classList.add(this.hiddenClass);
            }
        }

        async renderPages() {
            console.log('renderPages called');
            try {
                let promises = [];
                vela.recentlyViewed.products.forEach((handle, index) => {
                    console.log(`Processing product ${index}: ${handle}`);
                    
                    // CAMBIO IMPORTANTE: Removemos la condición index !== 0
                    if (handle && index < this.limit) {
                        const url = `${window.Shopify.routes.root}products/${handle}?view=product-card`;
                        console.log('Fetching URL:', url);
                        
                        promises.push(
                            fetch(url)
                                .then(response => {
                                    console.log(`Response for ${handle}:`, response.status);
                                    return response.text();
                                })
                                .then(text => {
                                    if (text && text !== '') {
                                        console.log(`Got content for ${handle}`);
                                        let productItem = document.createElement('div');
                                        const productItemClass = this.layout === 'grid' ? 'col' : 'slick-carousel__item';
                                        productItem.classList.add(productItemClass);
                                        productItem.innerHTML = text;

                                        return {
                                            element: productItem,
                                            handle: handle,
                                            index: index
                                        };
                                    } else {
                                        console.log(`Empty content for ${handle}`);
                                        return null;
                                    }
                                })
                                .catch(e => {
                                    console.error(`Error loading product ${handle}:`, e);
                                    return null;
                                })
                        );
                    }
                });

                console.log('Waiting for all promises...');
                let data = await Promise.all(promises);
                console.log('Data received:', data);
                
                let addedCount = 0;
                data.forEach(item => {
                    if (item && 'element' in item) {
                        this.container.append(item.element);
                        addedCount++;
                    }
                });
                
                console.log(`Added ${addedCount} products`);
                
                if (addedCount > 0) {
                    this.afterRenderPage();
                } else {
                    console.log('No products added, hiding section');
                    this.classList.add(this.hiddenClass);
                }
            } catch (e) {
                console.error('Error in renderPages:', e);
            }
        }

        afterRenderPage() {
            console.log('afterRenderPage called');
            this.classList.remove(this.hiddenClass);
            
            if (typeof vela !== 'undefined' && typeof vela.swatchProduct === 'function') {
                vela.swatchProduct();
            }

            if (typeof vela !== 'undefined' && vela.wishlist && typeof vela.wishlist.updateWishlist === 'function') {
                vela.wishlist.updateWishlist();
            }

            if (this.layout === 'carousel') {
                console.log('Initializing carousel');
                if (typeof $ !== 'undefined') {
                    setTimeout(() => {
                        $('body').trigger('carousel:init', '.js-recently-viewed');
                    }, 100);
                }
            }
            
            if (typeof $ !== 'undefined') {
                setTimeout(() => {
                    $('body').trigger('vela:countdown', '[data-countdown]');
                }, 100);
            }
        }
    }
    
    if (!customElements.get('product-recently-viewed')) {
        customElements.define('product-recently-viewed', ProductRecentlyViewed);
    }

  } catch(e) { console.error(e); }
})();
})();
